/**
 * 树形表格展开/收起图标（caret-right / caret-down），替代默认 +/- 图标
 */
export function createTableExpandIcon (h) {
  return function tableExpandIcon (props) {
    const { onExpand, record, expanded, expandable } = props
    if (!expandable) {
      return h('span', { class: 'ant-table-row-expand-icon ant-table-row-expand-icon-spaced' })
    }
    return h('a', {
      class: {
        'ant-table-row-expand-icon': true,
        'ant-table-row-expand-icon-custom': true,
        'ant-table-row-expand-icon-expanded': expanded
      },
      on: {
        click: e => onExpand(record, e)
      }
    }, [
      h('a-icon', { props: { type: expanded ? 'caret-down' : 'caret-right' } })
    ])
  }
}
